<template>
  <div class="examination">
    <div class="examination-play">
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "test"
  }
</script>

<style scoped>
  .examination{
    width: 100%;
    height: 32px;
  }

  .examination-play{
    width: 1150px;
    height: 32px;
    margin: 0 auto;
    padding-top: 1px;
  }


  .line{
    width: 1050px;
    height: 1px;
    background-color: #c7c7c7;
    margin-top: 20px;
    margin-left: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/test/components/test.vue